export enum AbTestCampaignNameEnum {
  NewUserJourney = 'new-user-journey',
}

export enum NewUserJourneyAbTestVariantEnum {
  Legacy = 'legacy',
  Orders = 'orders',
  ContinuousImprovement = 'continuous-improvement',
}

export const abTestDefaultVariantMapping = {
  [AbTestCampaignNameEnum.NewUserJourney]: NewUserJourneyAbTestVariantEnum.Legacy,
};
